<!--
 * @Author: WLL
 * @Date: 2020-03-21 20:47:46
 * @LastEditors: WLL
 * @LastEditTime: 2020-03-21 23:35:31
 * @Description: file content
 -->
<template>
  <div class="sj-editText" @click="onClick">
    <SjInput
      ref="input"
      class="sj-editText-input"
      size="mini"
      border
      v-model="data"
      @blur="onInputBlur"
      @keyup.enter="onInputKeyUp"
      v-show="isEditing"
      :padding="5"
    ></SjInput>
    <span class="sj-editText-label" v-show="!isEditing">{{
      formatter ? formatter(data) : data
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    formatter: {
      type: Function,
      default: null
    },
    valueFormatter: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      data: "",
      isEditing: false
    };
  },
  methods: {
    onClick() {
      this.isEditing = true;
      this.$nextTick(() => {
        this.$refs?.input?.focus();
      });
    },
    onInputBlur() {
      const { valueFormatter, data, value } = this;
      if (valueFormatter) {
        const valFinal = valueFormatter(data, value);
        this.$emit("input", valFinal);
        this.data = valFinal;
      } else {
        this.data = this.value;
      }
      this.isEditing = false;
    },
    onInputKeyUp() {
      this.$refs?.input?.blur();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.data = val;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-editText {
  display: inline-flex;
  align-items: center;
}
</style>
